import React, { useMemo } from 'react'
import { CountSummary } from "../attendance.types";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import LoadingSkeleton from "../../common/loading-skeleton/loading-skeleton";

interface IProps {
    data: CountSummary;
    isLoading: boolean;
}

const TodayStatusSplitChart: React.FC<IProps> = (props) => {

    const chartData = useMemo(() => {
        if (!props.data) return [];
        return [
            {
                name: 'Present',
                value: props.data.totalPresent
            },
            {
                name: 'Absent',
                value: props.data.totalAbsent
            },
            {
                name: 'On Leave',
                value: props.data.totalOnLeave
            }

        ]
    }, [props.data]);

    const PIE_COLORS = [
        'var(--success-border)',
        'var( --danger-border)',
        'var(--warning-border)',
    ];


    return (
        <section className="pn-attendance__card team-attendance-rate">
            <div className="pn-attendance__card__header">
                <h3 className="pn-attendance__card__title">Today's status split</h3>
                <span className="pn-attendance__card__subtitle">% of working days present this month</span>
            </div>
            <LoadingSkeleton loading={props.isLoading}>
                <ResponsiveContainer width="100%" height={240}>

                    <PieChart>
                        <Pie
                            data={chartData}
                            cx="50%"
                            cy="50%"
                            innerRadius={55}
                            outerRadius={80}
                            paddingAngle={3}
                            dataKey="value"
                            nameKey="name"
                            stroke="none"
                        >
                            {chartData.map((_, index) => (
                                <Cell
                                    key={`cell-${index}`}
                                    fill={PIE_COLORS[index % PIE_COLORS.length]}
                                    stroke="none"
                                />
                            ))}
                        </Pie>

                        <Tooltip
                            contentStyle={{
                                background: '#FFFFFF',
                                border: '1px solid #e2e8f0',
                                borderRadius: '8px',
                                fontSize: '12px',
                                fontWeight: 600,
                                color: '#0f172a',
                            }}
                        />

                        <Legend
                            layout="vertical"
                            verticalAlign="middle"
                            align="right"
                            iconType="circle"
                            iconSize={10}
                            formatter={(value, entry: any) => {
                                return (
                                    <span
                                        style={{
                                            color: 'var(--pn-text-primary)',
                                            fontSize: '13px',
                                            fontWeight: 500,
                                        }}
                                    >
                {value} : {entry.payload.value}
            </span>
                                );
                            }}
                        />
                    </PieChart>


                </ResponsiveContainer>
            </LoadingSkeleton>

        </section>
    )


}

export default TodayStatusSplitChart;
